import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { ProductFlag, toProductFlag } from "@/components/custom/ProductFlag";
interface Props {
  imageUrl?: string;
  imageAlt?: string;
  title: string;
  plpFlag?: string;
}
export function PlpProductCardThumbnail(t0) {
  const $ = _c(12);
  const {
    imageUrl,
    imageAlt,
    title,
    plpFlag
  } = t0;
  let t1;
  if ($[0] !== plpFlag) {
    t1 = toProductFlag(plpFlag);
    $[0] = plpFlag;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ProductFlag flag={t1} className="absolute top-6 left-6 z-10" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const flag = t2;
  if (!imageUrl) {
    let t3;
    if ($[4] !== flag) {
      t3 = <div className="relative aspect-square w-full bg-muted" data-testid="plp-product-card-thumbnail-placeholder">{flag}</div>;
      $[4] = flag;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  const t3 = imageAlt ?? title;
  let t4;
  if ($[6] !== imageUrl || $[7] !== t3) {
    t4 = <Image src={imageUrl} alt={t3} fill={true} className="object-contain" sizes="(min-width: 1024px) 25vw, (min-width: 768px) 50vw, 100vw" />;
    $[6] = imageUrl;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== flag || $[10] !== t4) {
    t5 = <div className="relative aspect-square w-full bg-muted">{flag}{t4}</div>;
    $[9] = flag;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}